import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PrivatePageWrapper from '../pages/privatePageWrapper/PrivatePageWrapper';
import Home from '../pages/home/Home';
import FormWrapper from '../components/formWrapper/FormWrapper';
import ReportPage from '../pages/reportPage/ReportPage';
import PrivateRoute from './PrivateRoute';
import { privatePagesList, publicPagesList } from '../constants/pages';
import Login from '../pages/accessPages/login/Login';
import UserForm from '../pages/user/UserForm';
import UserList from '../pages/user/UserList';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route exact path='/' element={<PrivateRoute/>}>
          <Route path="/" element={<PrivatePageWrapper slug="home" pageTitle="Home" menuParent="">
            <Home />
          </PrivatePageWrapper>} />

          {Object.values(privatePagesList).map((v) => (
            <Route key={v.slug} path={`/${v.slug}`} element={<PrivatePageWrapper slug={v.slug} pageTitle={v.pageTitle} menuParent={v.menuParent}>
              {v.formWrapperType ? <FormWrapper slug={v.slug} type={v.formWrapperType} /> : <v.component slug={v.slug} />}
            </PrivatePageWrapper>} />
          ))}

        <Route path="usuarios/editar/:id" element={<PrivatePageWrapper slug="usuarios/editar" pageTitle="Editar usuário" menuParent="usuario/listar">
          <UserForm />
        </PrivatePageWrapper>} />

        <Route path="usuarios/registrar" element={<PrivatePageWrapper slug="usuarios/registrar" pageTitle="Registrar usuário" menuParent="usuario/listar">
          <UserForm />
        </PrivatePageWrapper>} />

        <Route path="usuarios/listar" element={<PrivatePageWrapper slug="usuarios/listar" pageTitle="Listar usuários" menuParent="usuario/listar">
          <UserList />
        </PrivatePageWrapper>} />


        </Route>
        <Route exact path='/login' element={<Login/>}/>
        <Route path="*" element={<PrivatePageWrapper slug="home" pageTitle="Home" menuParent="">
          <Home />
        </PrivatePageWrapper>} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
